export default __webpack_public_path__ + "static/media/collab.6264f624.jpg";